let forms = {
	declaration_form: {
		icon: 'fa fa-user',
		title: 'Change Profile',
		subtitle: 'Change your profile details',
		forms: [
			{
				type: 'checkbox',
				class: 'col-12 custom-check',
				model: 'declaration',
				validation: 'required',
				label: '<div class="small">I agree that the information provided is correct.</div>',
			},
		],
	},
	benefits_form: {
		icon: 'fa fa-user',
		title: 'Change Profile',
		subtitle: 'Change your profile details',
		forms: [
			{
				type: 'select',
				class: 'col-12',
				model: 'risk_benefit',
				filterable: true,
				clearable: true,
				options: [],
				validation: '',
				label: 'Risk Benefit',
			},
		],
	},
	policy_cancelation_remarks: {
		icon: 'fa fa-user',
		title: 'Cancel Policy',
		subtitle: 'Policy Cancellation Remarks',
		forms: [
			{
				type: 'textarea',
				class: 'col-12',
				rows: 3,
				model: 'remarks',
				validation: 'required|min:10|max:1000',
				label: 'Cancelation Remarks',
			},
		],
	},
};

module.exports = {
	forms: utils.generateAllFormData(forms),
};
